<template>
  <MgdAlert v-if="reason === 'user-session-timeout'" variant="information">
    <Icon name="lucide:info" />
    <MgdAlertTitle>You've been signed out</MgdAlertTitle>
    <MgdAlertDescription>
      Your session has expired due to inactivity.
      <br />
      Please log in again to continue.
    </MgdAlertDescription>
  </MgdAlert>
  <MgdAlert v-else-if="reason === 'service-unavailable'" variant="danger">
    <Icon name="lucide:alert-triangle" />
    <MgdAlertTitle>Failed to log in</MgdAlertTitle>
    <MgdAlertDescription>
      Unable to login due to a required service being unreachable.
      <br />
      Please wait a while then try to log in again.
    </MgdAlertDescription>
  </MgdAlert>
  <MgdAlert v-else-if="reason === 'internal-server-error'" variant="danger">
    <Icon name="lucide:alert-triangle" />
    <MgdAlertTitle>Failed to log in</MgdAlertTitle>
    <MgdAlertDescription>
      <p>
        An unexpected error occurred while trying to log in.
        <br />
        Please try again.
        <br />
        If this problem persists then contact Midland support by phone at
        <a class="italic" href="tel:18004374056">1-800-437-4056</a> or by email
        at
        <a class="italic" href="mailto:info@midlandgaragedoor.com"
          >info@midlandgaragedoor.com</a
        >.
      </p>
    </MgdAlertDescription>
  </MgdAlert>
</template>

<script setup lang="ts">
import type { ApiErrorCode } from "~~/shared/api/errors";

defineProps<{ reason: ApiErrorCode | undefined }>();
</script>
